export const VesselUtils = {
  vesselActionRequired: function (details) {
    return (
      details.no_action ||
      details.sighting_report ||
      details.vessel_boarding ||
      details.port_control ||
      details.vessel_inspection ||
      details.airport_control ||
      details.aeroplane_inspection ||
      details.crew_list ||
      details.passenger_list ||
      details.other_actions
    )
  }
}
